<template>
  <!-- 已办任务 -->
  <div style="position: relative;">
    <el-form ref="formMyApprovedTask"  style="margin:5px 0" :model="formFilter" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350"  operatorPosition='start'>
        <el-form-item label="工单状态" prop="flowStatus">
          <el-select class="filter-item" v-model="formFilter.flowStatus" placeholder="工单状态" clearable>
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" v-show="item.name !== '已结束' && item.name !== '已撤销' && item.name !== '暂存'" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="审核时间" prop="createDate">
          <date-range class="filter-item"
            v-model="formFilter.createDate"
            :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>

        <el-form-item label="项目名称" prop="formFilter.projectName">
          <el-select style="width:100%" filterable  :clearable="true" v-model="formFilter.projectName" placeholder="项目名称">
            <el-option
              v-for="(item,index) in projectList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供货方名称" prop="formFilter.supplierName">
          <el-input class="filter-item" v-model="formFilter.supplierName" :clearable="true" placeholder="供货方名称" />
        </el-form-item>
        <div  style="margin: 0 0 15px 30px">
           <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="handleSearch">查询</el-button>
           <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        </div>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="teacher" :data="handlerTaskWidget.dataList" :size="defaultFormItemSize" @sort-change="handlerTaskWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="handlerTaskWidget.getTableIndex" />
          <el-table-column label="流程名称" prop="processDefinitionName" width="130px" show-overflow-tooltip />
          <el-table-column label="项目名称" prop="projectName" width="600px" show-overflow-tooltip />
          <el-table-column label="供货方名称" prop="supplierName" width="200px" show-overflow-tooltip />
          <el-table-column label="合同编号" prop="contractNo" width="200px" show-overflow-tooltip />
          <el-table-column label="合同金额" prop="contractAmount" width="150px" show-overflow-tooltip />
          <el-table-column label="审核时间" prop="endTime" width="200px" />
          <el-table-column label="执行操作" width="150px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{SysFlowTaskOperationType.getValue(scope.row.approvalType)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发起时间" prop="createTime"  width="200px" />
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <!-- <el-button class="table-btn primary " :size="defaultFormItemSize" type="text" @click="onRemindClick(scope.row)">催办</el-button> -->
              <el-button class="table-btn" :size="defaultFormItemSize" type="text" @click="getFlow(scope.row)">流程图</el-button>
              <el-button class="table-btn success" :size="defaultFormItemSize" type="text" @click="onTaskDetail(scope.row)">详情</el-button>
              <!-- <el-button class="table-btn delete" :size="defaultFormItemSize" type="text" @click="onCancelWorkOrder(scope.row)">撤销</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="handlerTaskWidget.totalCount"
            :current-page="handlerTaskWidget.currentPage"
            :page-size="handlerTaskWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="handlerTaskWidget.onCurrentPageChange"
            @size-change="handlerTaskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>    
    <el-dialog
      :visible="visible"
      width="1000px"
      top='5vh'
      :before-close="onClose"
    >
      <formTaskProcessViewer v-if="record.processDefinitionId && visible"  :flag="false"  :processDefinitionId='record.processDefinitionId'  :processInstanceId='record.processInstanceId' />
    </el-dialog>
  </div>
</template>

<script>
// import { Dialog } from 'element-ui'
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { FlowOperationController } from '@/api/flowController.js';
import { ContractDeptController } from '@/api/index.js';
import formTaskProcessViewer from "./formTaskProcessViewer.vue";
import { OnlineOperation } from '@/api/onlineController.js';

export default {
  name: 'formMyApprovedTask',
  props:{
    options:{
      type :Array,
      default : () => []
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  components:{
    formTaskProcessViewer
  },
  props:{
    options:{
      type :Array,
      default : () => []
    }
  },
  data () {
    return {
      formFilter: {
        flowStatus: undefined,
        createDate: [],
        projectName:undefined,
        supplierName: undefined
      },
      formFilterCopy: {
        flowStatus: undefined,
        createDate: [],
        projectName:undefined,
        supplierName: undefined
      },
      handlerTaskWidget: new TableWidget(this.loadHandlerTaskData, this.loadHandlerTaskVerify, true, false,null,false,null,localStorage.getItem('page') ? JSON.parse(localStorage.getItem('page')).pageParam.pageNum : 1),
      isInit: false,
      record:{},
      visible:false,
      projectList:[]
    }
  }, 
  created(){
    this.init()
    const row = JSON.parse(localStorage.getItem('task'))
    if (row) {
      this.onTaskDetail(row)
    }
    const search = JSON.parse(localStorage.getItem('search'))
    if (search) {
      this.formFilter = search
      this.formFilterCopy = search
    }
  },
  mounted() {
    localStorage.removeItem('page')
  },
  methods: {
    handleSearch(){
      this.refreshFormMyApprovedTask(true)
      localStorage.removeItem('page')
    },
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
    },
    onReset () {
      this.formFilter= {
        flowStatus: undefined,
        createDate: [],
        projectName:undefined,
        supplierName: undefined
      }
      this.formFilterCopy= {
        flowStatus: undefined,
        createDate: [],
        projectName:undefined,
        supplierName: undefined
      },
      this.refreshFormMyApprovedTask(true);
    },
    // // 催办
    // onRemindClick (row) {
    //   FlowOperationController.remindRuntimeTask(this, {
    //     workOrderId: row.workOrderId
    //   }).then(res => {
    //     this.$message.success('催办成功');
    //   }).catch(e => {});
    // },
    // // 撤销
    // onCancelWorkOrder (row) {
    //   this.$confirm('是否撤销此工单？').then(res => {
    //     let params = {
    //       workOrderId: row.workOrderId,
    //       cancelReason: '主动撤销'
    //     }
    //     FlowOperationController.cancelWorkOrder(this, params).then(res => {
    //       this.$message.success('撤销成功！');
    //       this.refreshFormMyApprovedTask(false);
    //     }).catch(e => {});
    //   }).catch(e => {});
    // },
    /**
     * 获取已办任务列表
     */
    loadHandlerTaskData (params) {
      if (params == null) params = {};
      if(params.pageParam.pageNum !== 1) {
        localStorage.setItem('page',JSON.stringify(params))
      } else {
        localStorage.removeItem('page')
      }
      params = {
        ...params,
        flowStatus: this.formFilterCopy.flowStatus,
        beginDate: this.formFilterCopy.createDate[0],
        endDate: this.formFilterCopy.createDate[1],
        projectName: this.formFilterCopy.projectName,
        supplierName: this.formFilterCopy.supplierName
      }
      return new Promise((resolve, reject) => {
        ContractDeptController.listHistoricTask(this, params).then(res => {
          resolve({
            dataList: res.data.dataList.map(item => {
              let formInfo = JSON.parse(item.formKey);
              return {
                ...item,
                formInfo
              }
            }),
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 校验已办任务过滤参数
     */
    loadHandlerTaskVerify () {
      this.formFilterCopy.flowStatus = this.formFilter.flowStatus;
      this.formFilterCopy.projectName = this.formFilter.projectName
      this.formFilterCopy.supplierName = this.formFilter.supplierName
      this.formFilterCopy.createDate = Array.isArray(this.formFilter.createDate) ? [...this.formFilter.createDate] : [];
      return true;
    },
    /**
     * 刷新已办任务列表
     */
    refreshFormMyApprovedTask (reloadData = false) {
      if (reloadData) {
        this.handlerTaskWidget.refreshTable(true, 1);
      } else {
        this.handlerTaskWidget.refreshTable();
      }
      localStorage.setItem('search',JSON.stringify(this.formFilterCopy))
    },
    /**
     * 详情
     */
    onTaskDetail (row) {
      localStorage.setItem('task',JSON.stringify(row))
      let params = {
        taskId: row.id,
        processDefinitionId: row.processDefinitionId,
        processInstanceId: row.processInstanceId
      }
      FlowOperationController.viewHistoricTaskInfo(this, params).then(res => {
        
        if(row.processDefinitionName === "付款审批单") {
          FlowOperationController.listWorkOrder(this, {
            flowWorkOrderDtoFilter: {
              serialNo:row.serialNo
            },
            pageParam:{
              pageSize:1,
              pageNum: 1
            }
          }, {
            processDefinitionKey: 'all'
          }).then(rs => {

        this.$router.push({
          name: res.data.routerName || 'handlerFlowTask',
          query: {
            serialNo:row.serialNo,
            processDefinitionKey: row.processDefinitionKey,
            taskId: row.id,
            processInstanceId: row.processInstanceId,
            processDefinitionId: row.processDefinitionId,
            formId: (row.formInfo || {}).formId,
            routerName: row.routerName,
            readOnly: true,
            flowEntryName: row.processDefinitionName,
            processInstanceInitiator: row.processInstanceInitiator,
            // 在已办理任务中仅显示加签和撤销操作
            operationList: res.data.operationList.filter(item => {
              return item.type === this.SysFlowTaskOperationType.CO_SIGN || item.type === this.SysFlowTaskOperationType.REVOKE;
            }),
            flowStatus: rs.data.dataList[0] && rs.data.dataList[0].flowStatus === 3 ?  '已办结' : '未办结',
            flag: false, // change wang 2023/3/10
            form:true
          }
        });
          })
        } else {
          
        this.$router.push({
          name: res.data.routerName || 'handlerFlowTask',
          query: {
            serialNo:row.serialNo,
            processDefinitionKey: row.processDefinitionKey,
            taskId: row.id,
            processInstanceId: row.processInstanceId,
            processDefinitionId: row.processDefinitionId,
            formId: (row.formInfo || {}).formId,
            routerName: row.routerName,
            readOnly: true,
            flowEntryName: row.processDefinitionName,
            processInstanceInitiator: row.processInstanceInitiator,
            // 在已办理任务中仅显示加签和撤销操作
            operationList: res.data.operationList.filter(item => {
              return item.type === this.SysFlowTaskOperationType.CO_SIGN || item.type === this.SysFlowTaskOperationType.REVOKE;
            }),
            flowStatus: '未办结',
            flag: false,// change wang 2023/3/10
            form:true
          }
        });
        }
      }).then(res => {});
    },
    onResume () {
      this.refreshFormMyApprovedTask();
    },
    initFormData () {
    },
    formInit () {
      this.refreshFormMyApprovedTask();
    },
    // 查看流程图
    getFlow(record){
      this.record = record
      this.visible = true
    },
    onClose(){
      this.visible = false
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style>
</style>
